<div class="deferred-service">
  <div class="content">
    <div class="ui-g-12 mt-2 justify-content-end p-zero">
      <div class="my-3 ui-g-5 float-right p-0 deferred-side-vehicle">
        <!-- <i class="fal fa-cars additional-icon" [ngClass]="{ 'text-primary fa-car': selectedVehicle?._id }"></i> -->
        <i *ngIf="selectedVehicle?._id" class="fal fa-times clear-vehicle-filter-btn p-2 pointer" [ngClass]="{ 'text-primary': selectedVehicle?._id }" (click)="clearVehicleFilter()"></i>

        <app-auto-complete
          placeholder="Search vehicle"
          field="title"
          theme="border"
          [suggestions]="_vehicles"
          [closeOnSelection]="true"
          [hasEditableField]="false"
          [hasCustomEditableField]="false"
          [autoFocus]="false"
          [hasSearchIcon]="true"
          [value]="searchKey"
          [isLoading]="isVehiclesLoading"
          (appSelect)="onSelectVehicle($event)"
          (appEnter)="onSearchEnter($event)"
          (appClear)="clearVehicleFilter()"
          (appCompletedMethod)="searchVehicle($event)"
          scrollHeight="264px"
        >
          <ng-template let-item appTemplate="item" let-index="index">
            <div>
              <span class="search-item d-flex">
                <div class="icon-box pl-1">
                  <i class="fal fal fa-cars font-16 pt-2"></i>
                </div>
                <div class="data-box w-100 pl-2">
                  <div>
                    <b>{{ item?.name }}</b>
                    <!-- <span class="float-right font-10 category-text font-10">{{ item?.email }}</span> -->
                  </div>
                </div>
              </span>
              <p *ngIf="index === _vehicles?.length -1 && _vehicles.length < totalRecords && !dontShowOnSearch" class="font-primary mb-0 p-2 flex-center-center" (click)="$event.stopPropagation();onScroll($event)">
                Show more
                <i *ngIf="isLoadingMore" class="fal fa-spinner rotate ml-2"></i>
              </p>
            </div>
          </ng-template>
        </app-auto-complete>
      </div>
    </div>

    <div class="ui-g-12 deferred-service-card mb-3 p-0" *ngFor="let order of orders?.services; let serviceIndex = index">
      <!-- Service header -->
      <div class="ui-g-12 service-head flex-between-start width-100p">
        <!-- Left service header -->
        <div class="flex-column flex-between-center width-100p">
          <div class="width-100p flex-between-center">
            <p id="link-open-estimate-name" class="font-13 font-bold estimate-name flex-between-center font-secondary-800 pointer m-0 text-truncate">
              <i class="far fa-car mr-2"></i>
              {{ order?.vehicleName }} ({{ vehicleDataMap[order?.vehicleId]?.isActive ? 'Active' : 'Inactive' }})
            </p>
          </div>

          <div class="width-100p flex-between-center">
            <span [hidden]="vehicleDataMap[order?.vehicleId]?.licensePlate === '' && vehicleDataMap[order?.vehicleId]?.vin === ''">
              (
              <span [hidden]="vehicleDataMap[order?.vehicleId]?.vin === ''"> VIN: <span [innerHTML]="vehicleDataMap[order?.vehicleId]?.vin | highlightVin"></span> </span>

              <span [hidden]="vehicleDataMap[order?.vehicleId]?.licensePlate === '' || vehicleDataMap[order?.vehicleId]?.vin === ''"> | </span>

              <span [hidden]="vehicleDataMap[order?.vehicleId]?.licensePlate === ''"> License Plate: {{ vehicleDataMap[order?.vehicleId]?.licensePlate }} </span>
              )
            </span>
          </div>
        </div>
      </div>

      <div *ngFor="let service of order?.services; let serviceIndex = index" class="ui-g-12 service-body">
        <div class="estimate-card ui-g p-0">
          <a class="ui-g-12 p-0 flex-start-center mb-1 font-colors">
            <div class="ui-g-8 flex-start-center p-0 height-full">
              <div class="flex-column flex-center-start width-100p">
                <div class="width-90p flex-start-center">
                  <p id="link-open-estimate-name" class="font-13 font-600 estimate-name font-secondary-800 pointer m-0 text-truncate">
                    {{ service?.title }}
                  </p>

                  <div *ngIf="isMultiLocationEnabled && service?.shopId" class="location-pill ml-2">
                    <span class="location-bg" [ngStyle]="{ backgroundColor: shopsMap[service?.shopId]?.shopColor }"></span>

                    <p class="location-name" [ngStyle]="{ color: shopsMap[service?.shopId]?.shopColor }">
                      <i class="fal fa-store-alt"></i>
                      {{ shopsMap[service?.shopId]?.shopName }}
                    </p>
                  </div>
                </div>

                <div class="width-100p">
                  <span class="font-11 estimate-details">
                    <i class="fal fa-clock"></i>&nbsp;
                    {{ service?.itemCount?.labor }}
                  </span>

                  <span class="font-11 estimate-details pl-2">
                    <i class="fal fa-tools"></i>&nbsp;
                    {{ service?.itemCount?.part }}
                  </span>

                  <span class="font-11 estimate-details pl-2">
                    <i class="fal fa-tire"></i>&nbsp;
                    {{ service?.itemCount?.tire }}
                  </span>

                  <span class="font-11 estimate-details pl-2">
                    <i class="far fa-ballot-check"></i>&nbsp;
                    {{ service?.itemCount?.other }}
                  </span>

                  <!-- <span class="badge badge-pill badge-deferred ml-3">{{ service?.serviceStatus }}</span> -->
                </div>

                <div class="width-100p" style="line-height: 1">
                  <span class="font-11 estimate-details" *ngIf="service?.estimate?.estimateCode">
                    Added on
                    <span class="font-bold pointer hover-ro open-link-container">
                      <app-open-tab-link
                        link="/estimate/{{ service.estimate.estimateId }}"
                        [tabId]="service.estimate.estimateId"
                        [title]="service.estimate.estimateCode"
                        [showForHistory]="true"
                        [reloadRequired]="true"
                      >
                      </app-open-tab-link>
                    </span>
                    on
                    {{ service?.createdAt | date : 'MMM d, yyyy h:mm a' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="ui-g-4 p-0 flex-column flex-center-end estimate-price height-full">
              <div id="text-estimate-price" class="mb-1">
                <span class="font-bold font-secondary-800 pl-2 font-13">
                  {{ service?.serviceTotal?.total | currency : usd }}
                </span>

                <span class="pl-2">
                  <button
                    class="btn btn-submit btn-white"
                    [disabled]="!vehicleDataMap[order?.vehicleId]?.isActive || order?.isTransferActive"
                    [ngClass]="{ 'not-allowed': !vehicleDataMap[order?.vehicleId]?.isActive || order?.isTransferActive }"
                    (click)="onAddRO(service)"
                  >
                    Add
                  </button>
                </span>

                <span class="pl-2 pointer font-secondary-800" (click)="!order?.isTransferActive && onDeleteDefrred(service, order)">
                  <i class="fal fa-trash" [ngClass]="{ 'not-allowed': order?.isTransferActive }"></i>
                </span>
              </div>

              <div class="pr-1"></div>
            </div>
          </a>

          <!-- history start -->
          <a class="ui-g-12 flex-start-center mb-1 font-colors p-0">
            <div class="width-100p">
              <div class="pt-1">
                <div class="estimates-heading font-11 font-secondary-800 font-600">History</div>
              </div>
            </div>
          </a>

          <div *ngFor="let history of service?.serviceAuthHistory" class="ui-g-12 p-0 font-11 flex-start-center width-100p font-gray-65 history-line-item">
            <div class="history-time flex-start-center">
              <i class="fal fa-{{ serviceAuthIcons[history?.status] }} pr-2"></i>

              <p class="m-0">
                {{ history?.createdAt | date : 'MMM d, yyyy hh:mma' }}
              </p>
            </div>

            <div class="history-method text-truncate">
              {{ history?.methodText }}
            </div>

            <div class="history-created-by text-truncate">by {{ history?.fullName }}</div>

            <div class="history-total">
              {{ history?.serviceTotal || 0 | currency : usd }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

